import React from 'react';
import clsx from 'clsx';
import SvgRingilWordmark from '@icons/ringil-wordmark.svg?react';

interface ComponentProps {
  /** Space available to the right of the content; the mark hides when there is too little. */
  restWidth: number;
}

/** Below this the mark would crowd the content rather than fill emptiness. */
const MIN_REST_WIDTH = 240;

/**
 * The RINGIL wordmark filling the empty region to the right of the content, flush with the right
 * edge of the shell as in the design's "2560 - menu" frame. The rotation is baked into the SVG's
 * viewBox rather than applied with CSS, so the element's layout box is genuinely tall and lines up
 * against right-0 — a CSS transform would leave the original wide box behind and offset the mark.
 */
const AppWatermark: React.FC<ComponentProps> = ({ restWidth }) => {
  if (restWidth < MIN_REST_WIDTH) return null;

  return (
    <div aria-hidden className={clsx('pointer-events-none select-none absolute right-0 inset-y-0 flex items-center overflow-hidden')}>
      <SvgRingilWordmark className={'w-auto h-[70vh] max-h-[820px] text-content-quaternary'} />
    </div>
  );
};

export default AppWatermark;
